import { Button, DataSource, HorizontalSpacer, Label, Layout, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutEdiCustomFilename extends Layout {
    buttonTestFilename: Button;
    horizontalspacer1: HorizontalSpacer;
    labelMoveable: Label;
    sourceCustomFilename: DataSource;
    tableFilename: Table;
    textboxExtension: Textbox;
    textboxNodeDelimiter: Textbox;
    textboxPrefix: Textbox;
    textboxSampleFilename: Textbox;
}
